import { config } from "../configs";

// tranche module
export const TrancheBotV2Status = {
  PENDING: "Pending",
  ACTIVE: "Draft - Ready for Review",
  SENT_FOR_APPROVAL: "Sent for Approval",
  SUCCESS: "Success",
  REJECTED: "Rejected",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  EXPIRED: "Expired",
  ZOHO_FAILED: "Zoho Failed",
};

export const TrancheLogIcon = {
  RED: "Red",
  YELLOW: "Yellow",
  GREEN: "Green",
};

export const TrancheModule = {
  TRANCHE: "Tranche",
  TRANCHE_BOT: "Tranche Bot",
};

// environment
export const isDevelopment = "development" === config.NODE_ENV;
export const isStaging = "staging" === config.NODE_ENV;
export const isProduction = "production" === config.NODE_ENV;

// This array defines the 4 steps of your timeline.
// Each object maps a step to its label and corresponding statuses.
export const TIMELINE_STEPS = [
  {
    step: 1,
    label: "Initiated",
    statuses: [
      TrancheBotV2Status.PENDING,
      TrancheBotV2Status.FAILED,
      TrancheBotV2Status.CANCELLED,
    ],
  },
  {
    step: 2,
    label: "Draft",
    statuses: [TrancheBotV2Status.ACTIVE],
  },
  {
    step: 3,
    label: "Sent for Approval",
    statuses: [TrancheBotV2Status.SENT_FOR_APPROVAL],
  },
  {
    step: 4,
    label: "Completed",
    statuses: [
      TrancheBotV2Status.SUCCESS,
      TrancheBotV2Status.REJECTED,
      TrancheBotV2Status.ZOHO_FAILED,
    ],
  },
];

/*
[
  { label: "0%", value: "0" },
  { label: "0.5%", value: "0.5" },
  { label: "1%", value: "1" },
  ...
  { label: "23%", value: "23" }
]
*/
export const scenerioOptions = Array.from({ length: 47 }, (_, i) => {
  const value = (i * 0.5).toString();
  return { label: `${value}%`, value };
});

export const assetColumnId = {
  statusId: "6842e76cde64330232cc886a",
};

export const virtualColumnIds = [
  "6842e76cde64330232cc886a",
  "6867c574490df933a1d0bc8a",
  "6867c4da490df933a1d0bc5c",
  "683eeb3d5a489901b765f98d",
  "690c2e0ad07e441402a8457d",
  "683eeb3d5a489901b765f996",
];

export const dealNameId = "683eeb3d5a489901b765f98d";

export const ContactParentFolderKey = {
  STANDARD_REPORTS: "Standard Reports",
  YEAR_END_REPORTS: "Year-End Reports",
  LLC_FORMATION_DOCUMENTS: "LLC Formation Documents",
};

export const previewFiles = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "svg",
  "pdf",
  "txt",
  "html",
  "mp4",
  "webm",
  "ogg",
  "mp3",
  "wav",
  // Documents
  "application/pdf",

  // Images
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/svg+xml",
  "image/apng",
  "image/avif",

  // Audio
  "audio/mpeg", // MP3
  "audio/ogg", // Ogg Vorbis
  "audio/wav", // WAV
  "audio/webm", // WebM Audio
  "audio/aac", // AAC

  // Video
  "video/mp4", // MP4 (H.264/AAC)
  "video/webm", // WebM (VP8/VP9/Opus)
  "video/ogg", // Ogg Theora

  // Text & Code
  "text/plain",
  "text/html",
  "text/css",
  "text/javascript",
  "application/javascript",
  "application/json",
  "application/xml",
  "text/xml",
];

// Report center key - Report center enum value
export const reportCenterKeyMapping = {
  "tsa-and-oma-contact-documents": "Tsa And Oma Contact Documents",
};

export const MONTH_OPTIONS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const ProductionReportFlagsEnum = {
  PR_V1: "PR_V1",
  PR_V2: "PR_V2",
};

// Production Reports static columns for the asset flags.
export const productionReport = [
  { label: "Estimate Exist", value: "estimateExist" },
  { label: "Record Id", value: "recordId" },
  { label: "Record Id (Deal)", value: "recordIdDeal" },
  { label: "Deal Name", value: "dealName" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
  { label: "Measurement Type", value: "measurementType" },
  { label: "Actual / Estimated %", value: "actualEstimatedPercent" },
  { label: "Actual Production", value: "actualProduction" },
  { label: "Net Estimate", value: "netEstimate" },
  { label: "Asset Id", value: "assetId" },
  { label: "Electricity Charged (kWh)", value: "electricityCharged" },
  { label: "Electricity Discharged (kWh)", value: "electricityDischarged" },
  { label: "PV: Total Actual Energy", value: "pvTotalActualEnergy" },
  { label: "Total Forecasted Energy", value: "totalForecastedEnergy" },
  { label: "Actual / Estimated % Storage", value: "actualEstimatedStorage" },
  { label: "Data Quality", value: "dataQuality" },
  {
    label: "Weighted Estimate Production",
    value: "weightedEstimateProduction",
  },
  { label: "PVWatts Monthly %", value: "pvWattsMonthlyPercent" },
  { label: "PV AC Monthly", value: "pvAcMonthly" },
];

// Production Reports V2 static columns for the asset flags.
export const productionReportV2 = [
  { label: "Estimate Exist", value: "estimateExist" },
  { label: "Record Id", value: "recordId" },
  { label: "Record Id (Deal)", value: "recordIdDeal" },
  { label: "Deal Name", value: "dealName" },
  { label: "Month", value: "month" },
  { label: "Year", value: "year" },
  { label: "Measurement Type", value: "measurementType" },
  { label: "Actual / Estimated %", value: "actualEstimatedPercent" },
  { label: "Actual Production", value: "actualProduction" },
  { label: "Net Estimate", value: "netEstimate" },
  { label: "Asset Id", value: "assetId" },
  { label: "Electricity Charged (kWh)", value: "electricityCharged" },
  { label: "Electricity Discharged (kWh)", value: "electricityDischarged" },
  { label: "PV: Total Actual Energy", value: "pvTotalActualEnergy" },
  { label: "Total Forecasted Energy", value: "totalForecastedEnergy" },
  { label: "Actual / Estimated % Storage", value: "actualEstimatedStorage" },
  { label: "Data Quality", value: "dataQuality" },
  {
    label: "Weighted Estimate Production",
    value: "weightedEstimateProduction",
  },
  {
    label: "Estimated Production Adjusted %",
    value: "estimatedProductionAdjustedPercentage",
  },
  { label: "PV AC Monthly", value: "pvAcMonthly" },
];


export const monthMap = {
  Jan: 1,
  Feb: 2,
  Mar: 3,
  Apr: 4,
  May: 5,
  Jun: 6,
  Jul: 7,
  Aug: 8,
  Sep: 9,
  Oct: 10,
  Nov: 11,
  Dec: 12,
};